var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagResultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#A760B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.97 16.139a1 1 0 0 0-1.213.728l-1.004 4.026H18a1 1 0 1 0 0 2h3.255l-.748 3H17a1 1 0 1 0 0 2h3.008l-.88 3.529a1 1 0 0 0 1.941.483l1-4.011h3.187l-.88 3.528a1 1 0 0 0 1.941.483l1-4.011H31a1 1 0 1 0 0-2h-3.184l.748-3H32a1 1 0 1 0 0-2h-2.937l.883-3.543a1 1 0 0 0-1.94-.484L27 20.893h-3.186l.883-3.542a1 1 0 0 0-.729-1.212zm2.533 6.755h-3.187l-.748 3h3.187l.748-3z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagResultIcon);
export default __webpack_public_path__ + "static/media/tag_result_icon.0c66a277fbdc726eda11845aa133da6c.svg";
export { ForwardRef as ReactComponent };